import { render, staticRenderFns } from "./CommitmentItem2617.vue?vue&type=template&id=1a510160&scoped=true&"
import script from "./CommitmentItem2617.vue?vue&type=script&lang=js&"
export * from "./CommitmentItem2617.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentItem2617.vue?vue&type=style&index=0&id=1a510160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a510160",
  null
  
)

export default component.exports